const __WEBPACK_NAMESPACE_OBJECT__ = require("tributejs/dist/tribute.esm.js");